import { lazy } from "react";
import { Route } from "react-router-dom";
import { AppRoutes, guestPath, protectedPath } from "@/infra/router";
import { InvalidPrescriptionStateGuard, PhysiotherapistDisconnectedGuard, PrescriptionExpiredGuard } from "../InvalidPatientStatusGuard";

const OnboardingBaseLayout = lazy(() => import("@/components/onboarding/OnboardingBaseLayout"));
const StartOnboardingPage = lazy(() => import("./StartOnboardingPage"));
const OnboardingInvitationCodePage = lazy(() => import("./OnboardingInvitationCodePage"));
const OnboardingTermsAndConditions = lazy(() => import("./OnboardingTermsAndConditions"));
const VerificationPage = lazy(() => import("./OnboardingVerificationPage"));

const OnboardingRevokedInvitation = lazy(() => import("./OnboardingRevokedInvitation"));
const OnboardingErrorPage = lazy(() => import("./OnboardingErrorPage"));

export const GUEST_ONBOARDING_ROUTES = (
  <>
    <Route
      aria-describedby="landing-page"
      path={guestPath(AppRoutes.Onboarding)}
      element={<StartOnboardingPage />}
    />
    {/* AppRoutes.Onboarding here is a layout wrapper, not a guest leaf page — not typed */}
    <Route path={AppRoutes.Onboarding} element={<OnboardingBaseLayout />}>
      <Route
        aria-describedby="onboarding-step-1"
        key={AppRoutes.OnboardingInvitationCode}
        path={guestPath(AppRoutes.OnboardingInvitationCode)}
        element={<OnboardingInvitationCodePage />}
      />
      {/* onboarding-step-2 is Auth0 password setup page */}
      <Route
        aria-describedby="onboarding-error-revoked"
        path={guestPath(AppRoutes.RevokedInvitation)}
        element={<OnboardingRevokedInvitation />}
      />
      <Route
        aria-describedby="onboarding-error-unknown"
        key={AppRoutes.OnboardingError}
        path={guestPath(AppRoutes.OnboardingError)}
        element={<OnboardingErrorPage />}
      />
    </Route>
  </>
);

export const PROTECTED_ONBOARDING_ROUTES = (
  <>
    <Route
      aria-describedby="onboarding-signup-verification"
      element={<VerificationPage />}
      path={protectedPath(AppRoutes.OnboardingVerify)}
      key={AppRoutes.OnboardingVerify}
    />
    {/* AppRoutes.Onboarding here is a layout wrapper shared with guest — not typed */}
    <Route path={AppRoutes.Onboarding} element={<OnboardingBaseLayout />}>
      <Route
        aria-describedby="onboarding-step-3"
        key={AppRoutes.OnboardingTermsAndConditions}
        path={protectedPath(AppRoutes.OnboardingTermsAndConditions)}
        element={<OnboardingTermsAndConditions />}
      />
    </Route>

    <Route
      key={AppRoutes.PrescriptionExpired}
      path={protectedPath(AppRoutes.PrescriptionExpired)}
      element={<PrescriptionExpiredGuard />}
    />
    <Route
      key={AppRoutes.InvalidPrescriptionState}
      path={protectedPath(AppRoutes.InvalidPrescriptionState)}
      element={<InvalidPrescriptionStateGuard />}
    />
    <Route
      key={AppRoutes.PatientDisconnected}
      path={protectedPath(AppRoutes.PatientDisconnected)}
      element={<PhysiotherapistDisconnectedGuard />}
    />
  </>
);

